var map = {
	"./Alpina_Gstaad.jpg": [
		115,
		0
	],
	"./Backstage_Zermatt.jpg": [
		116,
		1
	],
	"./Badrutt_St_Moritz.jpg": [
		117,
		12
	],
	"./Belvedere_Scuol.jpg": [
		118,
		23
	],
	"./Bergwelt_Grindelwald.jpg": [
		119,
		25
	],
	"./Chedi_Andermatt.jpg": [
		120,
		26
	],
	"./Chesa_Randolina_Sils.jpg": [
		121,
		27
	],
	"./Doldenhorn_Kandersteg.jpg": [
		122,
		28
	],
	"./Grand_Bellevue_Gstaad.jpg": [
		123,
		29
	],
	"./Kempinski_Engelberg.jpg": [
		124,
		30
	],
	"./Kernen_Schoenried_Gstaad.jpg": [
		125,
		2
	],
	"./Krone_La_Punt.jpg": [
		126,
		3
	],
	"./Kulm_St_Moritz.jpg": [
		127,
		4
	],
	"./Meisser_Guarda.jpg": [
		128,
		5
	],
	"./Palace_Gstaad.jpg": [
		129,
		6
	],
	"./Radisson_Andermatt.jpg": [
		130,
		7
	],
	"./Riffelalp_Zermatt.jpg": [
		131,
		8
	],
	"./Rockresort_Laax.jpg": [
		132,
		9
	],
	"./Schoenegg_Wengen.jpg": [
		133,
		10
	],
	"./Schweizerhof_Lenzerheide.jpg": [
		134,
		11
	],
	"./Schweizerhof_Zermatt.jpg": [
		135,
		13
	],
	"./Spitzhorn_Saanen.jpg": [
		136,
		14
	],
	"./Sporthotel_Pontresina.jpg": [
		137,
		15
	],
	"./Suvretta_St_Moritz.jpg": [
		138,
		16
	],
	"./Tschuggen_Arosa.jpg": [
		139,
		17
	],
	"./Waldhaus_st_Moritz.jpg": [
		140,
		18
	],
	"./Walther_Pontresina.jpg": [
		141,
		19
	],
	"./Zermatterhof_Zermatt.jpg": [
		142,
		20
	],
	"./Zurbriggen_Saas.jpg": [
		143,
		21
	],
	"./guardaval_Lenzerheid.jpg": [
		144,
		22
	],
	"./jungfrau-wengernalp.jpg": [
		145,
		24
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 82;
module.exports = webpackAsyncContext;